import {
  APIProvider, Map,
  AdvancedMarker,
  Pin
} from '@vis.gl/react-google-maps';
import { useMemo, useState } from "react";
import AreaContainer from "../AreaContainer";
import Nearby from "./Nearby";
import logEvent from "lib/ga/miscEvent"
import LazyImage from "components/LazyImage";

import styles from './whatsNearby.module.css';
import globalStyles from '../result.module.css';

interface Props {
  addressText: string,
  nearbyPlaces: any,
  resources, 
  name, 
  geo_location
}

const WhatsNearby = ({ addressText, nearbyPlaces, resources, name, geo_location }: Props) => {
  const [viewMap, setViewMap] = useState(false);

  const mapImage = useMemo(() => {
    let media =
      resources?.image?.map && resources.image.map.length > 0
        ? resources.image.map.sort((a, b) => {
          return b.id - a.id;
        })[0]
        : null;
    let image = media?.media && media.media.length > 0 ? media.media[0] : null;
    if (!image) return null;

    return {
      key: media.id,
      alt: media.name,
      src: `${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${image.uri}`,
      // src: 'https://maps.googleapis.com/maps/api/staticmap?size=1280x800&scale=2&format=jpg&center=51.395801500,0.112900000&zoom=15&key=AIzaSyDatP7hWmiiyXDW3li7KjXHMa6FiPDikxM',
      ratio: image.height / image.width,
      width: 740,
      height: 740 * (image.height / image.width),
      layout: "responsive",
    };
  }, [resources]);

  let map = {
    mapZoom: 15,
    mapMaxZoom: 20,
  };

  let location = {
    position: {
      lat: parseFloat(geo_location.lat),
      lng: parseFloat(geo_location.lon),
    },
  };

  const apiKey = process.env.NEXT_PUBLIC_GOOGLE_APIS_KEY_CSR ?? ''

  return (
    <AreaContainer area="whats-nearby" style={null} extraClass={undefined}>
      <div className={styles.NearbyWrapper}>
        <h2 className={globalStyles.subTitleText}>What's nearby</h2>
        <div className={styles.addressContain}>
          <div className={globalStyles.mediumText}>
            {addressText}
          </div>
        </div>
        {!viewMap && !mapImage && (
          <div className={styles.questionContainer}>
            <div className={globalStyles.subTitleText}>To view nearby places and a map of the surrounding area click below</div>
            <div className={styles.questionButton}
              onClick={() => {
                setViewMap(true);
              }}
            >
              See what's nearby
            </div>
          </div>)}
        {!viewMap && mapImage && (<div className={styles.MapImageContainer} >
          <LazyImage src={mapImage.src} alt="View map here" layout="fill" objectFit="cover" />
          <div className={styles.interactiveButton}  onClick={() => {
            logEvent({
              category: "Interactive Google Map",
              action: "google map open",
              label: `proeprty: ${name}`,
            });
            setViewMap(true);
            logEvent({
              category: "View nearby map",
              action: "Show nearby map",
              label: `View nearby map`,
              });
          }}
          >
            View Interactive Map
          </div>
        </div>
        )}
        {viewMap && (
          <APIProvider apiKey={apiKey} libraries={['marker']} >
            <div className={styles.MapContainer}>
              <Map
                mapId={'google-map-script'}
                defaultZoom={map.mapZoom}
                defaultCenter={location.position}
                gestureHandling={'greedy'}
              >
                <AdvancedMarker
                  position={location.position}
                  title={addressText}>
                  <Pin
                    background={'none'}
                    borderColor={'none'}
                    glyphColor={'none'}>
                    <img src={`${process.env.NEXT_PUBLIC_APP_CDN_URL}icons/property/map-icon.svg`} width={40} height={40} />
                  </Pin>
                </AdvancedMarker>
              </Map>
            </div>
          </APIProvider>
        )}
        {(viewMap || mapImage) && <Nearby data={nearbyPlaces} />}

      </div>
    </AreaContainer>
  );
};

export default WhatsNearby;